import api from '../../api/stoTrade'
import fastApi from '../../api/fast'

import {
  arrangeOrders,
  flattenOrders, pushNotExist,
  sortOrders, sortOrdersAsc
} from '../../utils/order-book'

export default {
  namespaced: true,
  state: {
    tradeHistory: null,
    tradeDate: null,
    trades: null,
    orders: [],
    offers: [],
    ordersLoading: false,
    tradesLoading: false,
  },
  getters: {
    tradeHistory(state) {
      return state.tradeHistory
    },
    trades(state) {
      return state.trades
    },
    offers(state) {
      return state.offers;
    },
    orders(state) {
      return state.orders;
    },
    getTradeDate(state) {
      return state.tradeDate
    },
    latestTrade(state) {
      const trades = state.trades
      return Array.isArray(trades) && trades.length > 0 ?
        trades[trades.length - 1].price :
        null
    },
    newTrade(state) { // TVChart-д ашиглана
      const trades = state.trades
      return Array.isArray(trades) && trades.length > 0 ?
          trades[trades.length - 1] :
          null
    }
  },
  mutations: {
    SET_TRADE_HISTORY(state, tradeHistory) {
      state.tradeHistory = tradeHistory
    },
    SET_TRADES(state, trades) {
      state.trades = trades
    },
    PUSH_TRADES(state, trade) {
      if (trade) {
        state.trades.push(trade)
      }
    },
    SET_TRADEDATE(state, date) {
      state.tradeDate = date;
    },
    SET_ORDERS(state, orders) {
      // state.orders = arrangeOrders(orders.filter(o => parseInt(o.type) === 0))
      // state.offers = arrangeOrders(orders.filter(o => parseInt(o.type) === 1))

      const _orders = orders.filter(o => parseInt(o.type) === 0);
      const _offers = orders.filter(o => parseInt(o.type) === 1);

      // if (_orders.length > 0) state.orders = arrangeOrders(_orders)
      state.orders = _orders

      // if (_offers.length > 0) state.offers = arrangeOrders(_offers)
      state.offers = _offers.reverse()
    },
    PUSH_ORDER(state, newOrder) {
      // Устсан эсэхийг тодорхойлох
      let orders = flattenOrders(state.orders)
      if (pushNotExist(orders, newOrder) === 0) return
      orders = sortOrders(orders)
      state.orders = arrangeOrders(orders)
    },
    PUSH_OFFER(state, newOffer) {
      // Устсан эсэхийг тодорхойлох
      let offers = flattenOrders(state.offers)
      if (pushNotExist(offers, newOffer) === 0) return
      offers = sortOrdersAsc(offers).reverse()
      state.offers = arrangeOrders(offers)
    },
    TOGGLE_LOADER(state, type) {
      state[type] = !state[type];
    },
  },
  actions: {
    async fetchTradeHistory({ commit }) {
      try {
        const { data } = await api.tradeAllHistory()
        commit('SET_TRADE_HISTORY', data)
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * Биелсэн захиалгын санг авах
     * @param commit
     * @param symbol
     * @returns {Promise<void>}
     */
    async fetchTrades({ commit }, symbol) {
      try {
        commit('TOGGLE_LOADER', 'tradesLoading')
        const { data } = await fastApi.trades(symbol)
        commit('SET_TRADES', data)
      } catch (error) {
        console.log(error)
      } finally {
        commit('TOGGLE_LOADER', 'tradesLoading')
      }
    },
    pushOrder({ commit }, payload) {
      commit('PUSH_ORDER', payload)
    },
    pushOffer({ commit }, payload) {
      commit('PUSH_OFFER', payload)
    },
    pushTrade({ commit }, payload) {
      commit('PUSH_TRADES', payload)
    },
    setOrders({ commit }, payload) {
      commit('SET_ORDERS', payload)
    },
    /**
     * Захиалгын санг авах
     * @param commit
     * @param symbol
     * @returns {Promise<void>}
     */
    async fetchOrderBook({ commit }, symbol) {
      try {
        commit('TOGGLE_LOADER', 'ordersLoading')
        const { data } = await fastApi.orders(symbol)
        commit('SET_ORDERS', data.data)
      } catch (error) {
        console.log(error)
      } finally {
        commit('TOGGLE_LOADER', 'ordersLoading')
      }
    },
    setTradeDate({ commit }, date) {
      commit('SET_TRADEDATE', date)
    }
  },
}
